import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventsRoutingModule } from './events-routing.module';
import { ListComponent } from './list/list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ForStudentComponent } from './for-student/for-student.component';
import { QuillModule } from 'ngx-quill';


@NgModule({
  declarations: [
    ListComponent,
    ForStudentComponent
  ],
  imports: [
    CommonModule,
    EventsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    PipeModule,
    NgxDatatableModule,  
    NgxMaskModule.forRoot(),
    NgxSpinnerModule,
    MatMenuModule,
    MatSlideToggleModule,
    QuillModule.forRoot(),
  ]
})
export class EventsModule { }
